/* 
 * Export component file to be used on project
*/

import ModalRepproveDetails from './ModalRepproveDetails.js';
export default ModalRepproveDetails;
